/**
 * @Date:   2018-01-22T09:58:52+08:00
 * @Last modified time: 2018-01-23T09:26:52+08:00
 */

import React from 'react';
import {connect} from 'react-redux';
import {addUser} from "../../actions/user-actions";

class User extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            username: "你好",
            email: "abc@123.com"
        }
    }
    componentDidMount() {
        console.log(this.props)
    }
    componentWillReceiveProps = (nextProps)=> {
        if(this.props.user !== nextProps.user){
            console.log("Component 组件内监听, 用户状态变更.");
            this.setState({
                username: nextProps.user.username,
                email: nextProps.user.email
            }, ()=>{
                console.log("组件State变更.");
            })
        }
    }
    onSubmit=()=>{
        console.log("Component发起事件请求.")
        this.props.addUser("我是用户", "我是邮箱");
    }
    render=()=>{
        return (
            <div>
                <a href="/"  onClick={this.onSubmit} >
                {"这是一个示例, 点击查看Console"}
                </a>
            </div>
        )
    }
}

function mapStateToProps(state){
    console.log("状态被映射到组件prop上.");
    console.log(state);
    return {
        user: state.user
    }
}
const actionCreators = {addUser};
User = connect(mapStateToProps, actionCreators)(User);
export default User;



// WEBPACK FOOTER //
// ./src/routes/User/user.js